import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import localforage from 'localforage';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  mainF2PercentState
} from '#state';

export function MainF2Percent() {
  const [percent, setPercent] = useRecoilState(mainF2PercentState);
  const [value, setValue] = useState(percent * 100);

  useEffect(() => {
    localforage.setItem('mainF2PercentState', percent);
  }, [percent]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);
    const v = parseFloat(newValue);
    if (v >= 0) {
      const p = parseFloat((v / 100).toFixed(4))
      setPercent(p);
    } else {
      setPercent(0.01);
    }
  };

  return (
    <TextField
      sx={{
        width: '5rem',
      }}
      label="M F2 %"
      type="number"
      size='small'
      inputProps={{ min: 0.01, step: 0.01 }}
      value={value}
      onChange={handleChange}
    />
  );
}

export default MainF2Percent;